import React from "react";
import { styled, TableCell, TableRow } from "@mui/material";
import { useNavigate } from "react-router-dom";

const StyledTableRow = styled(TableRow)`
  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
`;

const EmailsTableRow = ({
  email,
}) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`${email.userEmailEntityId}`);
  };

  return (
    <StyledTableRow onClick={handleRowClick}>
      <TableCell component="th" scope="row">
        {email.email}
      </TableCell>
      <TableCell align="right">{email.createDate}</TableCell>
      <TableCell align="right">{email.modifyDate}</TableCell>
    </StyledTableRow>
  );
};

export default EmailsTableRow;